import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { componentWithName } from '@tds/util-prop-types';
import Box from '@tds/core-box';
import { list } from '@tds/shared-styles';
import { safeRest } from '@tds/util-helpers';
import { small, medium, mediumFont, large, largeFont, smallFont } from '@tds/shared-typography';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

var StyledOrderedItem = styled.li.withConfig({
  displayName: "OrderedItem__StyledOrderedItem",
  componentId: "sc-124ihjc-0"
})(function (_ref) {
  var size = _ref.size;
  return _extends_1({
    marginLeft: '-1rem',
    paddingLeft: '1rem'
  }, size === 'small' && _extends_1({}, small, {
    letterSpacing: 'inherit'
  }), {}, size === 'medium' && _extends_1({}, medium, {}, mediumFont), {}, size === 'large' && _extends_1({}, large, {}, largeFont, {
    letterSpacing: 'inherit'
  }));
});
var StyledOrderedItemText = styled.span.withConfig({
  displayName: "OrderedItem__StyledOrderedItemText",
  componentId: "sc-124ihjc-1"
})(function (_ref2) {
  var size = _ref2.size;
  return _extends_1({}, size === 'small' && _extends_1({}, small, {}, smallFont), {}, size === 'medium' && _extends_1({}, medium, {}, mediumFont), {}, size === 'large' && _extends_1({}, large, {}, largeFont));
});

var OrderedItem = function OrderedItem(_ref3) {
  var children = _ref3.children,
      size = _ref3.size,
      rest = objectWithoutProperties(_ref3, ["children", "size"]);

  return React.createElement(StyledOrderedItem, _extends_1({
    size: size
  }, safeRest(rest)), React.createElement(StyledOrderedItemText, {
    size: size
  }, children));
};

OrderedItem.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
OrderedItem.defaultProps = {
  size: 'medium'
};
OrderedItem.displayName = 'OrderedList.Item';

var listStyleType = {
  upperAlpha: 'upper-alpha',
  lowerAlpha: 'lower-alpha',
  decimal: 'decimal'
};
var StyledOrderedList = styled(function (_ref) {
  var size = _ref.size,
      listStyle = _ref.listStyle,
      rest = objectWithoutProperties(_ref, ["size", "listStyle"]);

  return React.createElement(Box, rest);
})(function (_ref2) {
  var listStyle = _ref2.listStyle;
  return _extends_1({
    paddingLeft: '3rem',
    listStyleType: listStyleType[listStyle]
  }, list.base);
});
/**
 * @version ./package.json
 */

var OrderedList = function OrderedList(_ref3) {
  var listStyle = _ref3.listStyle,
      size = _ref3.size,
      children = _ref3.children,
      rest = objectWithoutProperties(_ref3, ["listStyle", "size", "children"]);

  return React.createElement(StyledOrderedList, _extends_1({}, safeRest(rest), {
    tag: "ol",
    between: 2,
    listStyle: listStyle
  }), React.Children.toArray(children).filter(function (child) {
    return child;
  }).map(function (child) {
    return React.cloneElement(child, {
      size: size
    });
  }));
};

OrderedList.propTypes = {
  /**
   * The bullet style.
   */
  listStyle: PropTypes.oneOf(['decimal', 'upperAlpha', 'lowerAlpha']),

  /**
   * The size of the list's text.
   *
   * @since 2.0.0
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The list items. Must be at least one `OrderedList.Item`.
   */
  children: componentWithName('OrderedItem').isRequired
};
OrderedList.defaultProps = {
  listStyle: 'decimal',
  size: 'medium'
};
OrderedList.Item = OrderedItem;

export default OrderedList;
export { StyledOrderedItem, StyledOrderedList };
